import React from 'react';

import 'normalize.css';
import '@app/styles/main.css';
import {Routing} from '@app/routing';
import {GlobalStyle} from '@app/styles/global';

export const App = () => (
    <>
        <GlobalStyle />
        <Routing />
    </>
);
